<template>
  <div class="shadow-blue-sm rounded bg-white p-3 mt-3">
    <h5 class="d-flex align-items-center mb-5">
      <span class="material-icons mr-2">local_shipping</span>Envío
    </h5>
    <div class="row mb-2">
      <div class="col-lg-6">
        <h5 class="mx-sm-auto pl-3">{{ shippingText }}</h5>
      </div>
      <div class="col-lg-1 text-right">
        <h5 class="mx-sm-auto">-</h5>
      </div>
      <div class="col-lg-5 text-right pr-5">
        <h5 class="text-danger mx-sm-auto">
          SC${{ shippingPrice.toFixed(2) }}
        </h5>
      </div>
    </div>
  </div>
</template>

<script>
import { CONSTANT_BUY } from "../../configs/contants"
export default {
  name: "ShippingDetail",
  props: {
    shippingType: {
      type: Number,
      default: 0,
    },
    shippingPrice: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      shippingPriceNew: 0,
      localCurrency: null,
    }
  },
  computed: {
      shippingText: function(){
          return CONSTANT_BUY.shippingType[this.shippingType]
      },
  },
};
</script>